import { z } from 'zod';
import { MOBILE_MONEY_PROVIDERS } from '../constants/index.js';
import { isValidCameroonIban, normalizeIban } from '../lib/iban.js';
import { isValidCameroonPhone, normalizeCameroonPhone } from '../lib/phone.js';

const FullName = z.string().trim().min(1, 'beneficiary.fullName.required').max(120);

export const BeneficiaryMobileMoneyDetails = z.object({
  provider: z.enum(MOBILE_MONEY_PROVIDERS),
  phone_number: z
    .string()
    .trim()
    .refine(isValidCameroonPhone, 'beneficiary.phone.invalid')
    .transform(normalizeCameroonPhone),
});

export const BeneficiaryBankDetails = z.object({
  bank_name: z.string().trim().min(1, 'beneficiary.bankName.required').max(120),
  iban: z
    .string()
    .trim()
    .refine(isValidCameroonIban, 'beneficiary.iban.invalid')
    .transform(normalizeIban),
  account_holder_name: z.string().trim().min(1, 'beneficiary.holderName.required').max(120),
});

export const BeneficiarySchema = z.discriminatedUnion('payout_method', [
  z.object({
    full_name: FullName,
    country: z.literal('CM').default('CM'),
    payout_method: z.literal('mobile_money'),
    payout_details: BeneficiaryMobileMoneyDetails,
  }),
  z.object({
    full_name: FullName,
    country: z.literal('CM').default('CM'),
    payout_method: z.literal('bank'),
    payout_details: BeneficiaryBankDetails,
  }),
]);
export type BeneficiaryInput = z.infer<typeof BeneficiarySchema>;

export const BeneficiaryUpdateSchema = BeneficiarySchema;
